<mat-form-field>
  <mat-select [formControl]="hoursCtrl" class="select-hours">
    <mat-select-trigger>
      {{ '' + hoursCtrl.value}}
    </mat-select-trigger>
    @for (hour of HOURS; track hour) {
    <mat-option [value]="hour">{{ hour }}</mat-option>
    }
  </mat-select>
</mat-form-field>

<span class="timepicker-separator">:</span>

<mat-form-field>
  <mat-select [formControl]="minutesCtrl" class="select-minutes">
    <mat-select-trigger>
      {{ '' + minutesCtrl.value}}
    </mat-select-trigger>
    @for (minute of MINUTES; track minute) {
    <mat-option [value]="minute">{{ minute }}</mat-option>
    }
  </mat-select>
</mat-form-field>

<span class="timepicker-gap"></span>

@if (format === 12) {
<mat-form-field>
  <mat-select [formControl]="ampmCtrl" class="select-ampm">
    <mat-select-trigger>
      {{ ampmCtrl.value.toUpperCase() }}
    </mat-select-trigger>
    <mat-option value="am">AM</mat-option>
    <mat-option value="pm">PM</mat-option>
  </mat-select>
</mat-form-field>
}
